import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { TRenderOptionType, TSingleSelectOption } from '../filter/model/ui-filter.types';
import { MOBILE_SCREEN_UTILS } from '../utils/mobile-screen.utils';
import { TranslateService } from '@ngx-translate/core';

export type TSingleSelectPopoverComponentDismissEmitVal =
  | {
      role: 'SELECTION';
      data: TSingleSelectOption;
    }
  | { role: undefined; data: undefined };

@Component({
  selector: 'monorepo-single-select-popover',
  templateUrl: './single-select-popover.component.html',
  styleUrls: ['./single-select-popover.component.scss'],
})
export class SingleSelectPopoverComponent implements OnInit, OnChanges {
  //props
  @Input() optionList: TSingleSelectOption[] = [];
  @Input() popoverRenderOptionType: TRenderOptionType = 'INLINE';
  @Input() selectedOption?: TSingleSelectOption;
  @Input() searchPlaceholder = 'single_select.Search';

  //component related Values
  showClose = false;
  filteredPopoverInfo: TSingleSelectOption[] = [];

  constructor(
    public popoverController: PopoverController,
    private modalController: ModalController,
    private translate: TranslateService,
  ) {
    this.showClose = MOBILE_SCREEN_UTILS.isMobileScreen();
  }

  ngOnInit() {
    this.setFilteredPopoverInfo();
  }

  ngOnChanges() {
    this.setFilteredPopoverInfo();
  }

  setFilteredPopoverInfo(optionList: TSingleSelectOption[] = this.optionList) {
    this.filteredPopoverInfo = optionList.map((x) => {
      return { ...x };
    });
  }

  onSearch($event: Event) {
    const searchValue = ($event.target as HTMLInputElement).value.toLowerCase();
    const optionList = this.optionList.filter(
      (item) =>
        item.displayName.toString().toLocaleLowerCase().includes(searchValue) ||
        item.value.toString().toLocaleLowerCase().includes(searchValue),
    );
    this.setFilteredPopoverInfo(optionList);
  }

  onOptionChange(option: TSingleSelectOption) {
    if (this.selectedOption && this.selectedOption.value === option.value) {
      this.close();
    } else {
      const selectedValue = option;
      if (this.popoverRenderOptionType === 'INLINE') this.popoverController.dismiss(selectedValue, 'SELECTION');
      else this.modalController.dismiss(selectedValue, 'SELECTION');
    }
  }

  close() {
    if (this.popoverRenderOptionType === 'INLINE') this.popoverController.dismiss();
    else this.modalController.dismiss();
  }
}
